import { faEdit } from '~components/icon';
import { Column, Row } from '~components/table-view-v3';
import { linkCellRender } from '~components/table-view-v3/columnRenderers';

import ServiceColourBadge from './ServiceColourBadge';

const columnsFactory = (
  setSelectedService: (service: any) => void,
  setSelectedColour: (colour: string) => void,
): Column[] => [
  {
    id: 'name',
    header: 'Service Name',
    type: 'text',
    // Fallback keeps the cell clickable for service types without a name
    deriveValue: (row) => row.name || '(no name)',
    renderReadOnly: linkCellRender((row: Row) => {
      const { id, name, colour } = row;
      setSelectedService({
        value: id,
        label: name,
        colour,
      });
      setSelectedColour(`${colour}`);
    }, faEdit),
  },
  {
    id: 'colour',
    header: 'Colour',
    type: 'custom',
    component: ServiceColourBadge,
    componentProps: (row: Row) => ({ rowData: row }),
  },
];

export default columnsFactory;
